import * as R from "ramda";
import * as RA from "ramda-adjunct";
import PropTypes from "prop-types";
import { Component } from "react";
import moment from "moment";
import cx from "classnames";
import HighlightText from "../../../../../Common/js/components/HighlightText/HighlightText.jsx";

export default class ResultItem extends Component {
  constructor(props) {
    super(props);
    this.itemWrapper = null;
  }

  componentDidMount() {
    this.itemWrapper.className = this.itemWrapper.className + " is-visible";
  }

  formatDate(dateStr) {
    const date = new Date(dateStr);
    return moment(date).format("MMMM Do, YYYY");
  }

  renderImage() {
    const { image1x1, contentUrl, title, body } = this.props;
    if (image1x1) {
      return (
        <figure className="list-item__media">
          <a href={contentUrl} title={title}>
            <img srcSet={image1x1} />
          </a>
          <figcaption className="u-visuallyhidden">{body}</figcaption>
        </figure>
      );
    } else {
      return <div className="list-item__media-shim">&nbsp;</div>;
    }
  }

  renderEyebrow() {
    const { contentUrl, eyebrowField, isHighlighted } = this.props;

    const eyebrow = this.props[eyebrowField];

    if (!eyebrow) {
      return null;
    }

    const isExternalLink =
      contentUrl &&
      (contentUrl.includes("http") || contentUrl.includes("www."));

    return (
      <h2
        className={cx("list-item__eyebrow", {
          "list-item__eyebrow--highlighted": isHighlighted,
        })}
      >
        <span>{eyebrow}</span>
        {isExternalLink && (
          <svg
            className="icon icon--arrow-right"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="none" fillRule="evenodd">
              <path
                d="M16.665 7.693c.07.072.133.152.176.242a1.097 1.097 0 01.009 1.122c-.045.088-.106.17-.175.251l-5.363 5.463a.752.752 0 01-1.08 0 .775.775 0 010-1.104L15.276 8.5l-5.046-5.168a.774.774 0 010-1.103.752.752 0 011.08 0l5.354 5.464z"
                fill="currentcolor"
              />
              <path
                d="M15.5 8.5h-11"
                stroke="currentcolor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </g>
          </svg>
        )}
        {isHighlighted && (
          <svg
            className="icon--24x24"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 700 700"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#0097A7"
              d="M466 74.8L350.4 8.1 72.3 168.7l115.6 66.7zM628.6 168.7l-115.7-66.8-115.6 66.8 115.6 66.7z"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#F70"
              d="M350.4 329.3L466 262.5l-115.6-66.7-115.6 66.7z"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#0097A7"
              d="M164.4 409.6V276.1L48.8 209.3v133.5z"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#F70"
              d="M326.5 503.2l.4-133.3-115.6-66.8v133.5z"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#0097A7"
              d="M325.9 690.5l.4-133.2L48.8 397v133.5z"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#F70"
              d="M489.5 436.7V303.2l-115.7 66.7-.4 133.8z"
            />
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#0097A7"
              d="M652 530.5V209.3l-115.6 66.8v321.1zM489.5 624.3V490.8L373.3 558l-.5 133.7z"
            />
          </svg>
        )}
      </h2>
    );
  }

  render() {
    const {
      title,
      body,
      contentType,
      date,
      authors,
      displayUrl,
      contentUrl,
      location,
      eyebrowField,
      topic,
      isHighlighted,
      query,
      wildcardResultsPageUrl,
      wildcardResultId,
    } = this.props;

    const formattedAuthors = R.compose(
      RA.mapIndexed((a, i) => (
        <span className="list-item__author" key={i}>
          {a}
        </span>
      )),
      R.intersperse(", "),
      R.reject(R.isEmpty),
    )(authors);

    const resultUrl = wildcardResultsPageUrl
      ? `${wildcardResultsPageUrl}?itemid=${wildcardResultId}`
      : contentUrl;

    const linkTarget =
      contentUrl && (contentUrl.includes("http") || contentUrl.includes("www."))
        ? "_blank"
        : null;

    return (
      <article
        className="list-item is-right"
        ref={(el) => (this.itemWrapper = el)}
      >
        <a
          className="list-item__content-link"
          href={resultUrl}
          target={linkTarget}
        >
          {this.renderEyebrow()}
          <div className="list-item__content">
            <header className="list-item__header">
              <h3 className="title list-item__title">{title}</h3>
            </header>
            <p className="list-item__description">
              <HighlightText query={query} text={body} />
            </p>
            {formattedAuthors.length > 0 && (
              <aside className="list-item__meta">
                <span className="list-item__byline">
                  by {formattedAuthors.map((author) => author)}
                </span>
              </aside>
            )}
          </div>
        </a>
      </article>
    );
  }
}

const { arrayOf, string, bool } = PropTypes;
ResultItem.propTypes = {
  date: string,
  authors: arrayOf(string),
  title: string.isRequired,
  body: string.isRequired,
  contentUrl: string.isRequired,
  displayUrl: string,
  contentType: string,
  location: string,
  image1x1: string,
  eyebrowField: string,
  wildcardResultsPageUrl: string,
  isHighlighted: bool,
  query: string,
  wildcardResultId: string,
};
